export var EditDraftsTableColumns = /*#__PURE__*/ function(EditDraftsTableColumns) {
    EditDraftsTableColumns["PrimaryContact"] = "Primary contact";
    EditDraftsTableColumns["AdditionalRecipients"] = "Additional recipients";
    EditDraftsTableColumns["AgreementName"] = "Agreement name";
    EditDraftsTableColumns["EffectiveDate"] = "Effective date";
    EditDraftsTableColumns["ModifiedBy"] = "Modified by";
    EditDraftsTableColumns["LastModified"] = "Last modified";
    EditDraftsTableColumns["ExpirationDate"] = "Expiration date";
    EditDraftsTableColumns["IntroductoryMessage"] = "Introductory message";
    EditDraftsTableColumns["IntroductoryVideo"] = "Introductory video";
    EditDraftsTableColumns["TermsOfService"] = "Terms of service";
    EditDraftsTableColumns["AgreementNote"] = "Agreement note";
    EditDraftsTableColumns["AutoApproveAmendments"] = "Auto approve amendments";
    EditDraftsTableColumns["AutoApproveOutOfScopeCharges"] = "Auto approve out-of-scope charges";
    EditDraftsTableColumns["NumberOfDaysUntilPaymentIsDue"] = "Number of days until the payment is due";
    EditDraftsTableColumns["PaymentMethodRequiredForSigning"] = "Allow proposal approval without payment method";
    EditDraftsTableColumns["CreditCardProcessingFees"] = "Card processing fees";
    EditDraftsTableColumns["ManualApprovalOfEachPayment"] = "Manual approval of each payment";
    return EditDraftsTableColumns;
}({});
export var ColumnSortId = /*#__PURE__*/ function(ColumnSortId) {
    ColumnSortId["PrimaryContact"] = "primaryContact";
    ColumnSortId["AdditionalRecipients"] = "additionalRecipients";
    ColumnSortId["AgreementName"] = "agreementName";
    ColumnSortId["EffectiveDate"] = "effectiveDate";
    ColumnSortId["ModifiedBy"] = "modifiedBy";
    ColumnSortId["LastModified"] = "lastModified";
    ColumnSortId["ExpirationDate"] = "expirationDate";
    ColumnSortId["IntroductoryMessage"] = "introductoryMessage";
    ColumnSortId["IntroductoryVideo"] = "introductoryVideo";
    ColumnSortId["TermsOfService"] = "termsOfService";
    ColumnSortId["AgreementNote"] = "agreementNote";
    ColumnSortId["AutoApproveAmendments"] = "autoApproveAmendments";
    ColumnSortId["AutoApproveOutOfScopeCharges"] = "autoApproveOutOfScopeCharges";
    ColumnSortId["NumberOfDaysUntilPaymentIsDue"] = "numberOfDaysUntilPaymentIsDue";
    ColumnSortId["PaymentMethodRequiredForSigning"] = "paymentMethodRequiredForSigning";
    ColumnSortId["CreditCardProcessingFees"] = "creditCardProcessingFees";
    ColumnSortId["ManualApprovalOfEachPayment"] = "manualApprovalOfEachPayment";
    return ColumnSortId;
}({});
